import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { media } from '@utex/ui-kit';

export const Container = styled('div')`
  display: flex;
  margin-top: 0.8rem;

  @media ${media.phonablet} {
    display: block;
  }
`;

export const heading = css`
  flex-shrink: 0;
  width: 12rem;
  margin-right: 1rem;

  @media ${media.phonablet} {
    width: 100%;
    margin-right: 0;
  }
`;

export const CaptionWrapper = styled('div')`
  display: flex;
  width: 100%;
`;

export const caption = css`
  width: calc(100% - 2.6rem - 1rem);
  margin-right: 0.8rem;
`;
